module.exports = __webpack_public_path__ + "static/media/reading-with-daughter.2a940e74.png";